/* unplugin-vue-components disabled */import script from "./IntegralHotelPriceOperate.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralHotelPriceOperate.vue?vue&type=script&setup=true&lang=js"

import "./IntegralHotelPriceOperate.vue?vue&type=style&index=0&id=bde3b748&lang=scss"

const __exports__ = script;

export default __exports__